export default __webpack_public_path__ + "static/media/Bracers of the Strange Beyond.94bfc0c0.jpg";